export class EntityOwner {
    public id: number = 0;
    public email?: string;
    public managedEntityId: number = 0;
    public managedEntityProjectIds: number[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): EntityOwner {
        const entityOwner: EntityOwner = new EntityOwner();

        entityOwner.id = this.id;
        entityOwner.email = this.email;
        entityOwner.managedEntityId = this.managedEntityId;
        entityOwner.managedEntityProjectIds = [...this.managedEntityProjectIds];

        return entityOwner;
    }
}
